import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

class ImporterBatchTool extends Component {
    constructor (props) {
        super(props);

        this.state = {
            batchModal: false
        };

        this.toggleBatchModal = this.toggleBatchModal.bind(this);
        this.submitBatchToggle = this.submitBatchToggle.bind(this);
    }

    toggleBatchModal (ev) {
        ev && ev.preventDefault();
        this.setState({
            batchModal: !this.state.batchModal
        });
    }

    submitBatchToggle () {
        this.toggleBatchModal();
        this.props.handleBatchToggleChange();
    }

    render () {

        const self = this;
        const { batchToggle, batchPrivacy } = this.props;

        function renderCategoryOptions () {
            return self.props.categories.data.map(function (category) {
                return (
                    <option key={'category-' + category.categoryID} value={category.categoryName}>
                        {category.categoryName}
                    </option>
                );
            });
        }

        return (<div id="batch-controls">
            <div id="batch-toggle">
                <button
                    className={'btn btn-' + (batchToggle ? 'default' : 'primary')}
                    disabled={this.props.csvData.length === 0}
                    onClick={this.toggleBatchModal}>
                        <i style={{marginRight: '.3rem'}} className={'fa fa-' + (batchToggle ? 'minus-circle' : 'plus-circle')}/>
                        {batchToggle ? "Omit" : "Include"} All
                </button>
            </div>
            <label id="batch-privacy" htmlFor="">
                <button
                    className={'btn btn-' + (batchPrivacy ? 'primary' : 'default')}
                    disabled={this.props.csvData.length === 0}
                    onClick={this.props.handleBatchPrivacyChange}>
                        {/*<i style={{marginRight: '.3rem'}} className={'fa fa-' + (batchPrivacy ? 'minus' : 'check')}/>*/}
                        {batchPrivacy ? "Set all Public" : "Set all Private"}
                </button>
            </label>
            <div id="batch-category">
                <select
                    disabled={this.props.csvData.length === 0}
                    className="form-control"
                    onChange={this.props.handleBatchCategoryChange}
                    value={this.props.batchCategory || ""}
                    name="batch-category">
                        <option value="" disabled>Select a Category &hellip;</option>
                        {renderCategoryOptions()}
                </select>
                    <button
                    disabled={this.props.csvData.length === 0}
                    id="batch-assign"
                    className="btn btn-primary"
                    onClick={this.props.onBatchCategoryAssignment.bind(null, this.props.batchCategory)}>
                    <i className="fa fa-clone"/> Batch Assign Category
                </button>
            </div>

            {this.state.batchModal ?
                <Modal animation={false} bsSize="large" show={this.state.batchModal} onHide={this.toggleBatchModal}>
                    <Modal.Header>
                        <Modal.Title>Are you Sure?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="alert alert-info">
                            <p>
                                This will toggle <strong>all</strong> of the Events in the pending list to <strong>{batchToggle ? "be omitted." : "be included."}</strong>
                            </p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-default" onClick={this.toggleBatchModal}>Cancel</button>
                        <button className="btn btn-primary" onClick={this.submitBatchToggle}>
                            <i className="fa fa-check"/> Toggle!
                        </button>
                    </Modal.Footer>
                </Modal> :
            null}
        </div>);
    }
}

ImporterBatchTool.propTypes = {};

export default ImporterBatchTool;
